<template>
  <div class="modal_user">
    <div class="modal_user__header">
      <h4 class="title">
        {{ primary_data.name }}
      </h4>
    </div>
    <div class="modal_user__body">
      <div class="user">
        <div class="tab">
          <span
            v-if="$store.getters.getPermissions.viewSelfProfile === true"
            class="tab_title"
            :class="{ active : block==='MainInfo'}"
            @click="selected_block('MainInfo')"
          >
            {{ translate('user.main_info.title') }}
          </span>
          <span
              v-if="$store.getters.getPermissions.viewSelfRoles === true"
              class="tab_title"
              :class="{ active : block==='RoleManagement'}"
              @click="selected_block('RoleManagement')"
          >
            {{ translate('user.role_manage.my_role') }}
          </span>
          <span
              v-if="$store.getters.getPermissions.viewSelfSettings === true"
              class="tab_title"
              :class="{ active : block==='Settings'}"
              @click="selected_block('Settings')"
          >
            {{ translate('user.settings .title') }}
          </span>
        </div>
        <div class="block">
          <MainInfo
              v-if="block==='MainInfo'"
              :main_info="main_info"
              @update_user="update_user"
          />
          <RoleManagement
              v-if="block==='RoleManagement'"
              :roles_and_permissions="roles_and_permissions"
          />
          <Settings
              v-if="block==='Settings'"
              :user_id="main_info.id"
              :settings="settings"
              @update_setting="update_setting"
          />
        </div>
      </div>


    </div>
    <div class="modal_user__footer">
      <div class="text-center">
        <button
          type="submit"
          class="btn btn-danger btn-fill btn-wd marginButton"
          @click.prevent="cancel"
        >
          {{ translate('close_modal') }}
        </button>
      </div>
    </div>

  </div>
</template>
<script>

import MainInfo from "./Tabs/MainInfo.vue";
import Settings from "./Tabs/Settings.vue";
import RoleManagement from "./Tabs/RoleManagement.vue";

export default {
  name: 'ShowUser',
  props: ['user', 'client_ids'],
  components: {
    MainInfo,
    Settings,
    RoleManagement
  },
  data () {
    return {
      block: 'MainInfo',
      disabled_btn: false,
      primary_data: {
        name: ''
      },
      roles_and_permissions: {},
      settings: {}
    }
  },
  created() {
    this.get_user_profile()

    this.primary_data = {...this.user}
  },

  computed:{
    main_info(){
      return {...this.primary_data}
    },
  },

  methods: {
    update_user(data){
      this.primary_data = data
      this.$emit('update')
    },
    update_groups(groups){
      this.primary_data.group = groups
      this.$emit('update')
    },
    update_setting(settings){
      this.settings = settings
    },
    cancel () {
      this.$emit('close')
    },
    selected_block(block){
      this.block = block
    },
    get_user_profile () {
      this.$http.v1.getUserProfile((response) => {
        this.roles_and_permissions.permissions = response.data.permissions
        this.roles_and_permissions.roles = response.data.roles

        this.settings = response.data.settings

        for (let block in this.settings) {
          for (let param in this.settings[block]) {
            this.settings[block][param].type = typeof(this.settings[block][param].value)
          }
        }

      })
    },
  }
}

</script>

<style lang='scss' scoped>
  .modal_user{
    height: 100%;
    padding: 10px;
    &__header{
      height: 5%;
      .title{
        margin: 0 0 10px 0;
        text-align: center;
      }
    }
    &__body{
      width: 100%;
      height: 90%;
      .loading{
        border:none;
        background-color: transparent;
      }
      .user{
        width: 100%;
        height: 100%;
        .tab{
          width: 100%;
          height: 5%;
          display: flex;
          align-content: center;
          justify-content: center;
          flex-direction: row;
          &_title{
            width: 100%;
            padding: 5px 0;
            cursor: pointer;
            font-weight: 600;
            text-align: center;
            background-color: #efe9e9;
            border: 1px solid #efe9e9;
            &.active{
              background-color: #FFFFFF;
              border-bottom: 1px solid white;
            }
          }
        }
        .block{
          height: 95%;
          border: 1px solid #efe9e9;
          margin-top: -1px;
          padding: 10px;
        }
      }

    }
    &__footer{
      height: 5%;
    }
  }
  .pointer{
    cursor: pointer;
    &:hover{
      background-color: #f3f3f3;
    }
  }


</style>
